<div id="errorModal" class="modal fade" data-keyboard="false" data-backdrop="static">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p *ngIf="errorText">
					<span class="error-text" [innerHtml]="errorText"></span>
				</p>
				<mat-spinner *ngIf="!errorText" class="mt-3"></mat-spinner>
			</div>
		</div>
	</div>
</div>
